<span>
  {{customer.totalVisits}} visit{{customer.totalVisits === 1 ? '' : 's' }}
  <ng-container *ngIf="customer.lastVisit">
    &middot; Last visit: {{ customer.lastVisit | trDateFormat:'MMM D, y': timezone}}
  </ng-container>
</span>